export const getCardUrl = ({
  slug = 'back',
  deckSlug = 'whispers-from-the-woods',
}: {
  slug?: string | undefined;
  deckSlug?: string | undefined;
} = {}) => `${import.meta.env['VITE_CDN_BASE_URL'] ?? ''}/decks/${deckSlug}/cards/${slug}.webp`;
